var _a;
export var IssueFormReason;
(function (IssueFormReason) {
    IssueFormReason["duplicateAppointment"] = "Duplicate Appointment";
    IssueFormReason["providerLateCancel"] = "Provider late cancel <24h";
    IssueFormReason["memberLateReschedule"] = "Member late reschedule <24h";
    IssueFormReason["wrongFamilyMember"] = "Wrong family member";
    IssueFormReason["other"] = "Other (Please specify)";
})(IssueFormReason || (IssueFormReason = {}));
export var IssueFormReasonLabels = (_a = {},
    _a[IssueFormReason.duplicateAppointment] = 'Duplicate Appointment',
    _a[IssueFormReason.providerLateCancel] = 'Provider late cancel <24h',
    _a[IssueFormReason.memberLateReschedule] = 'Member late reschedule <24h',
    _a[IssueFormReason.wrongFamilyMember] = 'Wrong family member',
    _a[IssueFormReason.other] = 'Other (Please specify)',
    _a);
